export const steps = {
  select: {
    id: 1,
    label: 'Select Award Unit',
    intlKey: 'wizard.select_award_unit',
    completed: false,
    active: true,
    path: '/select',
    next: '/details',
    allowedPaths: ['/details']
  },
  details: {
    id: 2,
    label: 'Award Unit Details',
    intlKey: 'wizard.award_unit_details',
    completed: false,
    active: true,
    path: '/details',
    next: '/authorising-contact',
    allowedPaths: ['/select', '/authorising-contact', '/nominated-award-leader']
  },
  authorisingContact: {
    id: 3,
    label: 'Authorising Contact',
    intlKey: 'wizard.authorising_contact',
    completed: false,
    active: true,
    path: '/authorising-contact',
    next: '/nominated-award-leader',
    allowedPaths: ['/details', '/nominated-award-leader', '/orb-account']
  },
  leader: {
    id: 4,
    label: 'Nominated Award Leader',
    intlKey: 'wizard.nominated_award_leader',
    completed: false,
    active: true,
    path: '/nominated-award-leader',
    next: '/award-leader-contact',
    allowedPaths: ['/authorising-contact', '/award-leader-contact']
  },
  leaderContact: {
    id: 5,
    label: 'Award Leader Contact',
    intlKey: 'wizard.award_leader_contact',
    completed: false,
    active: true,
    path: '/award-leader-contact',
    next: '/orb-account',
    allowedPaths: ['/nominated-award-leader', '/orb-account']
  },
  orbAccount: {
    id: 6,
    label: 'ORB Account',
    intlKey: 'wizard.orb_account',
    completed: false,
    active: true,
    path: '/orb-account',
    next: '/success',
    allowedPaths: ['/award-leader-contact', '/success', '/authorising-contact']
  }
}

export const rootPath = '/register/award-unit'

export const wizard = Object.keys(steps).map(item => {
  const currentStep = steps[item]
  let allowedPaths = currentStep.allowedPaths.concat(currentStep.next)

  allowedPaths = currentStep.allowedPaths.map(
    allowedPath => rootPath + allowedPath
  )

  return {
    id: currentStep.id,
    label: currentStep.label,
    completed: false,
    active: currentStep.active,
    intlKey: currentStep.intlKey,
    next: rootPath + currentStep.next,
    path: rootPath + currentStep.path,
    rootPath,
    allowedPaths
  }
})
